module.exports = __webpack_public_path__ + "img/74.dc93879b.jpg";